import { render, staticRenderFns } from "./reaction.vue?vue&type=template&id=d532402c&scoped=true&lang=pug"
import script from "./reaction.vue?vue&type=script&lang=js"
export * from "./reaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d532402c",
  null
  
)

export default component.exports